// AutoGenerated
export enum EnmCinsiyet {
    "Kadın" = 1,
    "Erkek" = 2,
}